// slices/ordersApiSlice.js
import { apiSlice } from './apiSlice';
import { ORDERS_URL, ORDERSOFFICE_URL, PAYPAL_URL } from '../constants';

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (order) => ({
        url: ORDERS_URL,
        method: 'POST',
        body: { ...order },
      }),
    }),

    getOrderDetails: builder.query({
      query: (id) => ({
        url: `${ORDERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    payOrder: builder.mutation({
      query: ({ orderId, details }) => ({
        url: `${ORDERS_URL}/${orderId}/pay`,
        method: 'PUT',
        body: { ...details },
      }),
    }),

    notPayOrder: builder.mutation({
      query: ({ orderId, details }) => ({
        url: `${ORDERS_URL}/${orderId}/notpay`,
        method: 'PUT',
        body: { ...details },
      }),
    }),

    getPaypalClientId: builder.query({
      query: () => ({
        url: PAYPAL_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ CLIENT : Ses propres commandes
    getMyOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ FORMATEUR : Commandes de ses produits seulement
    getFormateurOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/formateur`,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ ADMIN : Toutes les commandes
    getOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/orders`,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ OFFICE : Toutes les commandes
    getOrdersOffice: builder.query({
      query: () => ({
        url: `${ORDERSOFFICE_URL}/ordersOffice`,
      }),
      keepUnusedDataFor: 5,
    }),

    Clictopay: builder.mutation({
      query: (data) => ({
        url: `${ORDERS_URL}/${data.orderId}/clictopay`,
        method: 'POST',
        body: data,
      }),
    }),

    registerClicToPayOrder: builder.mutation({
      query: ({ orderId, amount }) => ({
        url: `/api/clic2pay/register/${orderId}/${amount}`,
        method: 'POST',
      }),
    }),

    getMyCourses: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/my-courses`,
      }),
      providesTags: ['PurchasedCourses'],
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useGetOrderDetailsQuery,
  usePayOrderMutation,
  useGetPaypalClientIdQuery,
  useGetMyOrdersQuery,
  useGetFormateurOrdersQuery, // ✅ NOUVEAU
  useGetOrdersQuery,
  useGetOrdersOfficeQuery,
  useNotPayOrderMutation,
  useClictopayMutation,
  useRegisterClicToPayOrderMutation,
  useGetMyCoursesQuery
} = ordersApiSlice;